import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';
import type { AutoCampaignHistoryItem } from './types';

export function useAutoCampaignHistory(
  projectId: string | undefined,
  limit = 25,
) {
  return useQuery({
    queryKey: ['auto-campaign', 'history', projectId, limit],
    queryFn: () =>
      apiGet<{ items: AutoCampaignHistoryItem[] }>(
        `/v1/projects/${projectId}/auto-campaign/history?limit=${limit}`,
      ),
    enabled: Boolean(projectId),
    // History changes at most every few hours (once per fire). No need to
    // hammer the server — 60s is plenty.
    refetchInterval: 60_000,
  });
}
